const initialState = {
  dropboxAuthSuccess: false,
  dropboxEventId: null,
};

export const dropboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DROPBOX_AUTH_SUCCESS":
      return { ...state, dropboxAuthSuccess: action.payload};
    case 'SET_DROPBOX_EVENT_ID':
      return { ...state, dropboxEventId: action.payload };

    default:
      return state;
  }
};
